import { functions } from '@/functions';
import {CONSTANTS} from '@/constants'

/*
    sm_functions.js
    Условия конечного автомата
    x - объект состояние которого обрабатывается
*/

export const sm_functions = {
    mixins: [functions],
    data: function () {
        return {};
    },
    methods: {
        canSmAgree: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmAccept: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmBook: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_NO_BOOKING:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmDeny: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmRevoke: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                case CONSTANTS.VOUCHER_STATE_QUOTA:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmRequest: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPresent: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmAbsent: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmRevert: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrebook: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrices: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmCancel: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    if (!this.smIsBookings(x)) return false;
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    if (!this.smIsBookings(x)) return false;
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                    if (!this.smIsBookings(x)) return false;
                case CONSTANTS.VOUCHER_STATE_DENIED:
                    if (!this.smIsBookings(x)) return false;
                case CONSTANTS.VOUCHER_STATE_QUOTA:
                case CONSTANTS.VOUCHER_STATE_DIRECT_PAY:
                case CONSTANTS.VOUCHER_STATE_DIRECT_PAY_MEET:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmClientPay: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmAgencyPay: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            if (!this.smIsActiveBookings(x)) return false;
            if (!this.smNotDirectPayment(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmSysPay: function(x) {
            if (!this.smIsManagerOrAgentWithContactsAccess(x)) return false;
            if (!this.smNotDirectPayment(x)) return false;
            if (!this.smHotelCompanyDefined(x)) return false;
            if (!this.smBookingsArePayedByAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmSkipPay: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmCheckout: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmCheckin: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_PERMITTED:
                case CONSTANTS.VOUCHER_STATE_DIRECT_PAY_MEET:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmDocsPrepare: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrint: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmAnnul: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_REFUSED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmRefuse: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmExecute: function(x) {
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmArchive: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmDrop: function(x) {
            if (!this.smNoBookings(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DENIED:
                    if (!this.smIsAgentOrAgency(x)) return false;
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                    if (!this.smIsAgentOrAgency(x)) return false;
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    if (!this.smIsAgentOrAgency(x)) return false;
                case CONSTANTS.VOUCHER_STATE_UNKNOWN:
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    if (!this.smIsAgentOrAgency(x)) return false;
                case CONSTANTS.VOUCHER_STATE_ORDERINWORK:
                case CONSTANTS.VOUCHER_STATE_NEWORDER:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintContract: function(x) {
            if (!this.smIsAgentOrManagerWithContactsAccess(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_ARCHIVED:
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_REFUSED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintVoucher: function(x) {
            if (!this.smIsAgentOrManagerWithContactsAccess(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_UNKNOWN:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_ARCHIVED:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintInvoice: function(x) {
            if (!this.smIsAgentOrManagerWithContactsAccess(x)) return false;
            if (!this.smIsClientInvoice(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_ARCHIVED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintHotelRequest: function(x) {
            if (!this.smIsManagerOrAgentWithContactsAccess(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintCheckinList: function(x) {
            if (!this.smIsAgentOrManagerWithContactsAccess(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPrintHotelChange: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_REFUSED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmShowVoucherTelecalls: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            return true;
        },
        canSmPrintHotelCancel: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_REVOKED:
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_REFUSED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmTest1: function(x) {
            return true;
        },
        canSmSetbook: function(x) {
            if (!this.smNoActiveBookings(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPermit: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            if (!this.smIsCheckinPermitted(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmAgentStatusControl: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_PRICED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmManagerStatusControl: function(x) {
            if (!this.smIsManagerOrBuh(x)) return false;
            /* non operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_RESERVED:
                case CONSTANTS.VOUCHER_STATE_CLIENT_PAYED:
                case CONSTANTS.VOUCHER_STATE_AG_PAYED:
                case CONSTANTS.VOUCHER_STATE_SYS_PAYED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PREPARED:
                case CONSTANTS.VOUCHER_STATE_DOCS_PRINTED:
                case CONSTANTS.VOUCHER_STATE_CHECKIN:
                case CONSTANTS.VOUCHER_STATE_CHECKOUT:
                case CONSTANTS.VOUCHER_STATE_ACCEPTED:
                case CONSTANTS.VOUCHER_STATE_NO_BOOKING:
                case CONSTANTS.VOUCHER_STATE_PERMITTED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmSetQuota: function(x) {
            if (!this.smIsManagerOrAgentWithContactsAccess(x)) return false;
            if (!this.smIsQuotaFlag(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmResetQuota: function(x) {
            if (!this.smIsManagerOrAgentWithContactsAccess(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_QUOTA:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmDirectPay: function(x) {
            if (!this.smIsManagerOrAgentWithContactsAccess(x)) return false;
            if (!this.smIsDirectPayment(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmDirectPayMeet: function(x) {
            if (!this.smIsDirectPayment(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_DIRECT_PAY:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmTake: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_NEWORDER:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmQueue: function(x) {
            if (!this.smIsNoCallNoDocument(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_ORDERINWORK:
                    return true;
                default:
                    return false;
            }
            return true;
        },
        canSmPreprocess: function(x) {
            if (!this.smIsAgentOrAgency(x)) return false;
            if (!this.smIsCallOrDocument(x)) return false;
            /* operations */
            switch (x.status_index) {
                case CONSTANTS.VOUCHER_STATE_ORDERINWORK:
                    return true;
                default:
                    return false;
            }
            return true;
        },
    }
};

